import moment from 'moment';
import { concat, forEach, map, reduce } from 'lodash';
import { CHINESE_LANGUAGE_ID, TRADITIONAL_CHINESE_LANGUAGE_ID } from 'containers/PatientPage/constants';
import { journeyEventTypes, normalizeDOB } from 'ui-utils';

export function patientRequestInterceptor(data, currentLocale) {
  const { culture, language, dateOfBirth, contact, ehrEnable, ehrId, ...patient } = data;
  const isChineseLanguage = language === CHINESE_LANGUAGE_ID || language === TRADITIONAL_CHINESE_LANGUAGE_ID;

  const date = moment(normalizeDOB(dateOfBirth, currentLocale), 'MM/DD/YYYY');
  const body = {
    ...patient,
    dateOfBirth: {
      year: date.format('YYYY'),
      month: date.format('MM'),
      day: date.format('DD'),
    },
    contact: map(contact, (item) => ({
      ...item,
      type: item.type === 'auto' ? 'sms' : item.type,
    })),
    language,
    ...(language && isChineseLanguage && { culture }),
  };

  if (!body._id && ehrEnable) {
    body.externalId = { source: 'none', value: ehrId };
  }

  delete body.insuranceData;
  delete body.ehrEnable;
  delete body.ehrId;

  return body;
}

export function patientResponseInterceptor(data) {
  const { dateOfBirth, insuranceData, ...patient } = data;
  let dateOfBirthValue;
  let dateOfBirthString;

  if (dateOfBirth) {
    const { year, month, day } = dateOfBirth;

    if (year && month && day) {
      dateOfBirthValue = moment()
        .year(year)
        .month(Number(month) - 1)
        .date(day);
      dateOfBirthString = dateOfBirthValue.format('MM/DD/YYYY');
    }
  }

  return {
    ...patient,
    dateOfBirthValue,
    // TODO skip storing dateOfBirthString instead of dob value
    dateOfBirth: dateOfBirthString,
    insuranceData: {
      size: insuranceData.length,
    },
  };
}

export function patientJourneyResponseInterceptor(value, includeDetails) {
  const today = moment();
  const todayEvent = {
    type: 'today',
    date: today,
    year: today.year(),
    month: today.month(),
  };
  let todayAdded;
  const response = reduce(
    value,
    (array, event) => {
      const { data } = event;
      let newItems = [];
      if (data) {
        const date = moment(event.start);
        const year = date.year();
        const month = date.month();
        const isFuture = date.isAfter();

        // Add `today` as an event to show in timeline
        if (includeDetails && isFuture && !todayAdded) {
          newItems.push(todayEvent);
          todayAdded = true;
        }
        forEach(journeyEventTypes, (type) => {
          const items = map(data[type], (details) => ({
            type,
            date,
            year,
            month,
            isFuture,
            details: details || {},
          }));
          newItems = concat(newItems, items);
        });
      }
      return concat(array, newItems);
    },
    [],
  );

  // Add `today` event at the end if there are no future events
  if (includeDetails && !todayAdded) {
    response.push({
      ...todayEvent,
      isLast: true,
    });
  }

  return {
    response,
    events: value,
  };
}
